<template>
    <div class="flex flex-col gap-6">

        <AiCard/>

        <PatentTrendMatrixCard/>

        <WordCloudCard/>

        <PatentTrendCard/>

        <PaperTrendCard/>

    </div>
</template>

<script setup lang="ts">
import AiCard from '@/components/AiCard.vue';
import PaperTrendCard from '@/components/PaperTrendCard.vue';
import PatentTrendCard from '@/components/PatentTrendCard.vue';
import WordCloudCard from '@/components/WordCloudCard.vue';
import PatentTrendMatrixCard from '@/components/PatentTrendMatrixCard.vue'
</script>
